import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm15.089 6.24-1.05-1.05a.771.771 0 0 0-.64-.22l-.46.07a1.73 1.73 0 0 0-.42-.83l-1.84-1.83c-2.06-2.06-4.87-.75-6.07.23a.752.752 0 0 0-.24.83.742.742 0 0 0 .7.5c.78.02 1.79.15 2.14.73.15.26.25.53-.25 1.03l-6.05 6.05a.754.754 0 0 0 0 1.06l1.68 1.69a.748.748 0 0 0 1.06 0l6.1-6.1c.01-.01.02-.01.02-.02a2 2 0 0 1-.04.24.794.794 0 0 0 .21.67l1.05 1.05a.754.754 0 0 0 1.06 0l3.04-3.04a.748.748 0 0 0 0-1.06Zm-11.97 6.67-.62-.63 5.23-5.23.63.62Zm8.4-4.16-.25-.25c.16-1.17-.11-1.44-.25-1.58a1.158 1.158 0 0 0-.81-.32 1.666 1.666 0 0 0-.65.15l-.9-.9a2.1 2.1 0 0 0-.17-1.95 2.58 2.58 0 0 0-1.16-1.02 2.261 2.261 0 0 1 2.29.56l1.82 1.81a1.508 1.508 0 0 1 .05.57.75.75 0 0 0 .22.62.768.768 0 0 0 .63.2l.9-.13.26.26Z';
const draw24px =
  'M22.94,9.06,21.31,7.42a.8.8,0,0,0-.64-.21l-1.12.16A2.38,2.38,0,0,0,19,5.92L16.11,3.07c-3-3-7.09-1-8.85.4A.74.74,0,0,0,7,4.29a.75.75,0,0,0,.69.51c1.92,0,3.15.48,3.66,1.33s.31,1.34-.44,2.09L1.57,17.59a.75.75,0,0,0,0,1.06l2.61,2.6a.75.75,0,0,0,1.06,0l9.43-9.43a2.56,2.56,0,0,1,.81-.55,7.81,7.81,0,0,1-.14,1.25.77.77,0,0,0,.21.67l1.63,1.63a.75.75,0,0,0,1.06,0l4.7-4.7a.75.75,0,0,0,0-1.06ZM4.71,19.66,3.16,18.12l8.69-8.68L13.39,11Zm13-6.43-.82-.82c.27-1.78-.09-2.14-.25-2.3a1.7,1.7,0,0,0-2.07-.06L12.78,8.26a2.83,2.83,0,0,0-.12-2.91A4.1,4.1,0,0,0,10,3.57c1.43-.63,3.45-1,5.05.56L17.89,7a2,2,0,0,1,.17,1.17.79.79,0,0,0,.23.63.74.74,0,0,0,.62.2l1.6-.23.84.84Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const HammerIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'hammer'),
) as IconWithRender;

HammerIcon.displayName = 'HammerIcon';
HammerIcon.propTypes = Icon.propTypes;
HammerIcon.renderIcon = (props) => <HammerIcon {...props} />;
export default HammerIcon;
